import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';

@Component({
  selector: 'app-main-navbar',
  templateUrl: './main-navbar.component.html',
  styleUrls: ['../navbar.component.scss','./main-navbar.component.scss']
})
export class MainNavbarComponent implements OnInit {
  constructor(private router: Router,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId:Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }
  public isBrowser: boolean = false;
  public showToUser: boolean = true;
  protected referalCode: string = this.route.snapshot.queryParams["reference"] || this.getCookie('referenceBhavani');
  platformBaseUrl = $localize.locale ==='es'? `https://my.bhavani.app/es/`: `https://my.bhavani.app/en/`
  navigation_links = [
    {
      name: $localize`Inicio`,
      path: '/',
      external: false
    }
    // {
    //   name: $localize`Nosotros`,
    //   path: '/about',
    //   external: false,
    // },
    // {
    //   name: $localize`Microdosis`,
    //   path: '/dosage',
    //   external: false,
    // },
    // {
    //   name: $localize`Tratamiento`,
    //   path: '/treatment',
    //   external: false,
    // },
    // {
    //   name: $localize`Blog`,
    //   path: '/blog',
    //   external: false,
    // },
    // {
    //   name: $localize`Mi perfil`,
    //   path: this.platformBaseUrl,
    //   external: true,
    // }
  ]
  ngOnInit(): void {
    this.checkRouteData();
    if (isPlatformBrowser(this.platformId)) {
      this.stickyNavbar();
    }
    setTimeout(() => {
      this.referalCode = this.getCookie('referenceBhavani');
    },400)
  }

  private checkRouteData() {
    this.router.events.subscribe((event) => {
      if (event instanceof RoutesRecognized) {
        event.state.root.firstChild?.data['noNav'] ? this.showToUser = false : this.showToUser = true;
      }
    });
  }
    stickyNavbar() {
    const navbar = this.document.getElementById("navbar");
    if (!navbar) return;
    let sticky = navbar.offsetTop;
      const platformId = this.platformId;  
    window.onscroll = function() {
      if (isPlatformBrowser(platformId)&&window.scrollY >= sticky) {
        navbar.classList.add("fixed-top")
      } else {
        navbar.classList.remove("fixed-top");
      }
    };
  }
  private getCookie(name: string) {
    if (!this.isBrowser) return '';
    let ca: Array<string> = this.document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
}
